import { Reveal } from "@/lib/motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS, BUSINESS, waLink } from "@/data/site";
import { MessageCircle } from "lucide-react";

export const Faq = ({ heading = true }) => {
  return (
    <section id="faq" className="relative py-20 md:py-28 bg-muted border-y border-border">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        {heading && (
          <div className="mb-12">
            <Reveal as="p" className="text-xs uppercase tracking-[0.2em] text-primary font-semibold">FAQ</Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-4 text-4xl md:text-5xl font-heading font-bold tracking-tight">
                Answers to common questions
              </h2>
            </Reveal>
            <Reveal delay={0.1} className="mt-4 text-muted-foreground text-lg">
              Everything you need to know before starting a project with us.
            </Reveal>
          </div>
        )}

        <Reveal>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-border">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left text-lg font-medium hover:text-primary hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal delay={0.1} className="mt-10 text-center">
          <p className="text-muted-foreground">Still have a question?</p>
          <a href={waLink(`Hi ${BUSINESS.name}, I have a question.`)} target="_blank" rel="noopener noreferrer"
            className="mt-3 inline-flex items-center gap-2 rounded-full bg-green-500 hover:bg-green-600 text-white font-semibold px-6 py-3 transition-colors">
            <MessageCircle className="w-4 h-4" /> Ask us on WhatsApp
          </a>
        </Reveal>
      </div>
    </section>
  );
};
